// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__nuYlL","buttons":"Footer_buttons__2r1a5"};